import React from "react";
import { Tooltip as RadixTooltip } from "radix-ui";

import css from "./tooltip.module.scss";

interface Props {
  children: React.ReactNode;
  content: React.ReactNode;
  distance?: number;
  paddingBlock?: number;
}

export function Tooltip({ children, content, distance = 7, paddingBlock = 8 }: Props) {
  return (
    <RadixTooltip.Provider>
      <RadixTooltip.Root delayDuration={0}>
        <RadixTooltip.Trigger asChild>{children}</RadixTooltip.Trigger>
        <RadixTooltip.Portal>
          <RadixTooltip.Content
            className={css.tooltip}
            style={{ "--paddingBlock": paddingBlock } as React.CSSProperties}
            sideOffset={distance}
          >
            {content}
          </RadixTooltip.Content>
        </RadixTooltip.Portal>
      </RadixTooltip.Root>
    </RadixTooltip.Provider>
  );
}
